<div class="bg-th-yellow mt-0 container-fluid py-2">
  <div class="d-flex justify-content-between align-content-center">
    <i class="fa fa-arrow-left text-secondary my-auto pointer text-dark"></i>
    <a class="d-flex align-items-center text-secondary f18 my-auto text-dark">
      <span class="fw-bold">
        گزارش تغذیه ({{ searchForm.value.strFullName }})</span
      >
    </a>
  </div>
</div>

<main class="px-2">
  <div class="border-2 container-fluid row gx-0 gy-2 mt-3 p-2">
    <!-- جستجو -->
    <div class="col-8 p-1">
      <input
        type="text"
        class="w-100 form-control"
        (input)="filterResult($event.target.value)"
        placeholder="جستجو کنید ..."
      />
    </div>

    <!-- نقشه -->
    <div class="col-auto p-1">
      <button
        class="w-100 h-100 btn btn-outline-secondary"
        (click)="showAllOnMap()"
      >
        &nbsp; نقشه &nbsp;
      </button>
    </div>

    <!-- خروجی اکسل -->
    <div class="col-auto p-1">
      <button class="w-100 h-100 btn btn-success" (click)="exportExcel()">
        &nbsp; خروجی اکسل &nbsp;
      </button>
    </div>

    <!-- جدول اطلاعات -->
    <div class="section border mt-2">
      <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        <thead>
          <tr class="text-center">
            <th scope="col" class="">#</th>
            <th scope="col" class="">عملیات</th>
            <th scope="col" class="">محل تغذیه</th>
            <th scope="col" class="">تاریخ</th>
            <th scope="col" class="">زمان شروع</th>
            <th scope="col" class="">زمان پایان</th>
            <th scope="col" class="">مقدار(لیتر)</th>
          </tr>
        </thead>

        <tbody>
          <tr
            class="f14 text-center"
            [ngClass]="getRowClass(item)"
            *ngFor="let item of supplyDetails; let i = index"
          >
            <th class="text-dark">{{ i + 1 | faNum }}</th>
            <td>
              <i
                class="fa fa-map-marker fa-lg pointer"
                title="موقعیت تغذیه"
                (click)="openMap(item)"
              ></i>
            </td>
            <td>{{ item.strTitle }}</td>
            <td>{{ item.strDate | faNum }}</td>
            <td>{{ item.strSTime | faNum }}</td>
            <td>{{ item.strETime | faNum }}</td>
            <td>{{ (item.fFeedingValue | number) | faNum }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="col-12 text-center">
            <th colspan="1">تعداد کل: {{ (supplyDetails.length | number) | faNum }}</th>
            <td colspan="5"></td>
            <td colspan="1">سرجمع: {{ (searchForm.value.feedingValue | number) | faNum }} </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</main>
